import { defineComponent, PropType } from 'vue'
import './index.scss'
import { BaseCreator, GfrContainer, ModuleBase, ModuleBaseHeader } from '#components'
import { moduleBaseProps } from '@/components/module/base'

interface Card {
  name: string
  desc: string
  images: string[]
  need_entrance: 0 | 1 | 2 // 0 无 ｜ 1 下载 ｜ 2 外链
  entrance_name: string
  entrance_icon: string
  entrance_link: string
  entrance_weight: number
  entrance_display_way: 'left' | 'right'
  status?: 0 | 1 // 0 ｜ 1
}

export default defineComponent({
  name: 'ModuleHomeScreen4',
  props: {
    ...moduleBaseProps,
    title: String,
    subtitle: String,
    cards: {
      type: Array as PropType<Card[]>,
      default: () => []
    }
  },
  setup(props) {
    const newCards = computed(() => {
      const activeCards = props.cards?.filter((item) => item.status === 1)
      return activeCards?.sort((a, b) => b.entrance_weight - a.entrance_weight)
    })
    const linkInfo = (type: 0 | 1 | 2, name: string, url: string) => {
      if (type) {
        return {
          name,
          url,
          download: type === 1
        }
      }
      return {}
    }
    return () => (
      <ModuleBase name={props.name} class={'module-home-creator-base'}>
        <GfrContainer class={['module-home-creator']}>
          <ModuleBaseHeader title={props.title} description={props.subtitle || ''} />
          <div class={'module-creator-list'}>
            {newCards.value?.map((card) => (
              <BaseCreator
                title={card.name}
                desc={card.desc}
                images={card.images}
                {...linkInfo(card.need_entrance, card.entrance_name, card.entrance_link)}
              />
            ))}
          </div>
        </GfrContainer>
      </ModuleBase>
    )
  }
})
